import { ModelConfigParams, genericEnd, genericStartQC } from "./model-config-params";

const prostateMiddleChecklist = [
  "Bladder - has been identified in the T2 axial weighted image and correctly labelled",
  "Prostate Gland - has been identified in the T2 axial weighted image and correctly labelled",
  "Urethra - has been identified in the T2 axial weighted image and correctly labelled",
  "Sphincter - has been identified in the T2 axial weighted image and correctly labelled",
  "Seminal vesicles - have been identified in the T2 axial weighted image and correctly labelled",
  "Neurovascular bundle - has been identified in the T2 axial weighted image and correctly labelled",
  "Lesions (tumour) - have been identified in the ADC, DWI high-b, T2 axial weighted image and correctly labelled in the T2 WI axial according to the PI-RADS score and information contained in the radiology report",
  "Biopsy cores - have been annotated on the 3D model according to the gleason ISUP score found in the histology report"
]

export const prostate: ModelConfigParams = {
  bodyParts: [
    'tumourProstate',
    'prostateWithTumourAndZones',
    'seminalVesicle',
    'prostateNeurovascularBundle',
    'bladder',
    'urethra',
    'urethralSphincter',
    'cyst',
    'pelvicBones',
    'prostateCentralZone',
    'prostatePeripheralZone',
    'prostateTransitionalZone',
    'prostateAFS',
    'unknown',
    'urine',
  ],
  tissueHotkeys: {
    tumourPIRADS3: 'q',
    tumourPIRADS3External: 'alt + q',
    tumourPIRADS4: 'w',
    tumourPIRADS4External: 'alt + w',
    tumourPIRADS5: 'e',
    tumourPIRADS5External: 'alt + e',
    seminalVesicle: 'r',
    bladder: 't',
    prostateNeurovascularBundle: 'y',
    urethra: 'u',
    urethralSphincter: 'i',
    unknown: 'o',
    prostate: 'p',
  },
  checklist: [
    prostateMiddleChecklist,
    genericEnd,
  ].flat(),
  checklistQC: [
    genericStartQC,
    prostateMiddleChecklist,
    genericEnd,
  ].flat(),
  defaultIntensityRange: [0, 2000],
}
